import React, { useEffect, useRef } from 'react'
import image1 from './images/1.svg';
import image2 from './images/2.svg';
import image3 from './images/3.svg';
import image4 from './images/4.svg';
import image5 from './images/5-1.svg';
import LogoDoang from './images/LogoDoang.svg';
import FotoProfil from './images/Profil.png';
import Reveal from './components/Reveal';
// import Countdown from './components/Countdown';
import Loader from './components/Loader';
import SkillBox from './components/SkillBox';
import Navbar from './components/Navbar';
import Project from './components/Project';
import { useParallax } from 'react-scroll-parallax';
import excel from './images/logo/skill/excel.svg';
import word from './images/logo/skill/word.svg';
import ppt from './images/logo/skill/powerpoint.svg';
import office from './images/logo/skill/office.svg';
import c from './images/logo/c.svg'
import java from './images/logo/java.svg'
import py from './images/logo/python.svg'
import tailwind from './images/logo/tailwind.svg'
import react from './images/logo/react.svg'
import js from './images/logo/skill/js.svg'
import fastapi from './images/logo/fastapi.svg'
import HTML from './images/logo/HTML.svg'
import CSS from './images/logo/skill/css.svg'
import flutter from './images/logo/skill/flutter.svg'
import haskell from './images/logo/skill/haskell.svg'
import prolog from './images/logo/skill/prolog.svg'
import figma from './images/logo/skill/figma.svg'
import canva from './images/logo/skill/canva.svg'
import ai from './images/logo/skill/ai.svg'
import nextJS from './images/logo/next-jsBlack.svg'
import cpp from './images/logo/cpp.svg'
import Experiences from './components/Experiences';
import Footer from './components/Footer';

// About Me: A brief introduction about yourself, your background, and your expertise.
// Skills: A list of your technical skills or areas of expertise.
// Projects: Showcase your previous work or projects with descriptions, screenshots, and links.
// Experience: Highlight your professional experience, including past jobs, internships, or freelance work.
// Education: Mention your educational background, degrees, and certifications.
// Contact: Provide contact information for potential clients or employers to reach out to you.
// Testimonials: Include testimonials or recommendations from previous clients or colleagues.
// Blog: If you have a blog, you can include a section to showcase your articles or writings.

function App() {
  const skillList = [
    {
      title: 'Basic Skills',
      skills: [
        {
          name: 'Excel/Spreadsheet',
          rate: 80,
          src: excel
        },
        {
          name : 'Word/Docs',
          rate: 100,
          src: word
        },
        {
          name : 'Powerpoint/Slide',
          rate: 100,
          src: ppt
        },
        {
          name : 'Other Office Tools',
          rate: 85,
          src: office
        },
      ]
    },
    {
      title: 'Tech Skills',
      skills: [
        {
          name:'HTML',
          rate: 90,
          src: HTML
        },
        {
          name:'CSS',
          rate: 65,
          src: CSS
        },
        {
          name:'Vanilla JS',
          rate: 60,
          src: js
        },
        {
          name:'React JS',
          rate: 60,
          src: react
        },
        {
          name:'Tailwind',
          rate: 85,
          src: tailwind
        },
        {
          name:'Fast API',
          rate: 70,
          src: fastapi
        },
        {
          name:'Flutter',
          rate: 45,
          src: flutter
        },
        {
          name:'Next JS',
          rate: 70,
          src: nextJS
        }
      ]
    },
    {
      title: 'Programing Language',
      skills: [
        {
          name:'Python',
          rate: 80,
          src: py
        },
        {
          name:'C',
          rate: 55,
          src: c
        },
        {
          name:'C++',
          rate: 70,
          src: cpp
        },
        {
          name:'Java',
          rate: 50,
          src: java
        },
        {
          name:'Haskel',
          rate: 40,
          src: haskell
        },
        {
          name:'Prolog',
          rate: 65,
          src: prolog
        },
      ]
    },
    {
      title: 'Visual Art',
      skills: [
        {
          name:'Figma',
          rate: 85,
          src: figma
        },
        {
          name:'Canva',
          rate: 70,
          src: canva
        },
        {
          name:'Adobe Illustrator',
          rate: 80,
          src: ai
        },
      ]
    },
    // {
    //   title: 'Soft Skills',
    //   skills: [
    //     {
    //       name:'Communication',
    //       rate: 90,
    //       src: LogoDoang
    //     },
    //     {
    //       name:'Teamwork',
    //       rate: 95,
    //       src: LogoDoang
    //     },
    //     {
    //       name:'Problem Solving',
    //       rate: 90,
    //       src: LogoDoang
    //     },
    //     {
    //       name:'Time Management',
    //       rate: 80,
    //       src: LogoDoang
    //     },
    //     {
    //       name:'Adaptability',
    //       rate: 85,
    //       src: LogoDoang
    //     },
    //   ]
    // }
  ]

  const target = useRef(null);
  const target1 = useRef(null);
  
  const LBG = useParallax({
    speed: 30,
    targetElement: target.current,
  });
  const L1 = useParallax({
    speed: 45,
    targetElement: target.current,
  });
  const L2 = useParallax({
    speed: 60,
    targetElement: target.current,
  });
  const L3 = useParallax({
    speed: 85,
    targetElement: target.current,
  });
  const L4 = useParallax({
    speed: 100,
    targetElement: target.current,
  });
  // const MAIN = useParallax({
  //   speed: 100,
  //   targetElement: target1.current,
  // });
  const L5 = useParallax({
    speed: 85,
    targetElement: target.current,
  });


  const [loading, setLoading] = React.useState(true);
  useEffect(() => {
    if (loading){
      setTimeout(() => {
        setLoading(false);
      }
      , 3000);
    }
  }, [loading]);
  
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);



  return (
    <>
    {loading && <Loader className="overflow-hidden fixed top-0 left-0"/>}
    <div className='scroll-smooth h-fit max-h-screen' id="parent">
      {!loading && <Navbar/>}
      <link rel="preconnect" href="https://fonts.googleapis.com"></link>
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin></link>
      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap" rel="stylesheet"></link>

     <div ref={target} className="anim-layer parallax scroll-smooth">
        <div ref={LBG.ref} className='anim-layer parallax' style={{backgroundImage: `url(${image5})`}}></div>
        <div ref={L1.ref} className='anim-layer parallax' style={{backgroundImage: `url(${image4})`}}></div>
        <div ref={L2.ref} className='anim-layer parallax' style={{backgroundImage: `url(${image3})`}}></div>
        <div ref={L3.ref} className='anim-layer parallax' style={{backgroundImage: `url(${image2})`}}></div>
        <div ref={L4.ref} className='anim-layer parallax h-[100vh]' style={{backgroundImage: `url(${image1})`}}>
          <div className='w-screen h-[100vh] bg-[#1c2333] translate-y-[100vh]'></div>
        </div>

        {/* secret top */}
        <div ref={L5.ref} className='w-full h-screen fixed flex justify-center items-center'>
          <div className='w-fit h-fit group'>
            <div className='absolute top-[16%] left-[50%] translate-x-[-50%] z-[10] opacity-0 group-hover:opacity-80 group-hover:blur'>
              <img className='' src={LogoDoang} width={400} alt='backblur'></img>
            </div>
            <div className='absolute top-[16%] left-[50%] translate-x-[-50%] z-[10] opacity-30 group-hover:opacity-100'>
              <img className='' src={LogoDoang} width={400} alt='front'></img>
            </div>
          </div>
        </div>
      </div>

      <div className='bg-[#1c2333] anim-layer1 parallax h-fit'>
        
        {/* main page here */}
        <div className='w-full h-fit flex flex-col justify-center items-center'>
          {/* <div className='w-[80%] py-20 flex flex-col gap-10 justify-start items-center'> */}
          <div className='w-[80%] h-fit pt-[100px] pb-[50px] flex flex-col justify-start items-center'>
            
            {/* section 1 */}
            <section ref={ref1} className='w-full h-fit min-h-screen flex flex-wrap justify-center items-center gap-10 snap-start scroll-smooth' id="Profile">
              <Reveal className='flex justify-center items-center'>
                <img src={FotoProfil} width={500} alt='Profile'></img>
                <div className='px-10 w-[47.8rem]'>
                  <div className='text-gray-300 text-3xl font-semibold text-justify'>Hi, I'm</div>
                  <div className='text-gray-200 text-6xl font-bold text-justify'>Valentino Chryslie Triadi</div>
                  <div className='py-1 text-gray-500 text-2xl font-normal text-wrap text-justify'>Undergraduate Student of <strong>Bandung Institute of Technology</strong> | Interest in <strong>Software Engineer</strong> | Currently serving as <strong>Backend Vice Manager ITB Fair 2024</strong>  | Experienced as <strong>Data Analyst Intern</strong> in <strong>Nexia Indonesia</strong></div>
                </div>
              </Reveal>
            </section>

            {/* section 2 */}
            <Experiences ref={ref2}/>
            
            {/* section 3 */}
            <Project ref={ref3}/>

            {/* section 4 */}
            <section className='w-full h-fit min-h-screen flex justify-center items-center flex-col gap-5' id="Skill">
              <div className='text-white text-7xl font-bold font-poppins text-center w-[80%] translate-y-[50px] pb-20'>Skills & Expertise</div>
              {skillList.map((skill, index) => {
                return <SkillBox title={skill.title} skills={skill.skills} key={index} />;
              })}
            </section>


            {/* section 4 */}
            {/* <Reveal className='flex py-[200px] justify-center items-center'>
              <div className='text-white text-5xl font-bold text-center py-10'>Date Countdown!</div>
              <input className='w-[50%] h-10 bg-transparent border border-white text-white text-center' placeholder='Enter Date Here'></input>
              <Countdown target="2024-1-2"/>
            </Reveal> */}


          </div>
          {/* footer */}
          <Footer/>
        </div>
      </div>
    </div>
    </>
  );
}

export default App;